<div class="filter-section">
  <div class="controls-single-row">
    <!-- Country: simple name only (no flag, no dropdown icon) -->
    <!-- <div class="country-selector-compact country-name-only" [matMenuTriggerFor]="countryMenu"  -->
    <div class="country-selector-compact country-name-only">
      <!-- matTooltip="Select Region" matTooltipPosition="below" -->
      <!-- <span class="flag-icon">{{ getCountryFlag(country) }}</span> -->
      <span class="country-text">{{ country }}</span>
      <!-- <mat-icon class="dropdown-icon">expand_more</mat-icon> -->
    </div>

    <!-- <mat-menu #countryMenu="matMenu" class="country-dropdown-menu">
      <button mat-menu-item *ngFor="let option of countryOptions" (click)="selectCountry(option)">
        <span class="flag-icon">{{ getCountryFlag(option) }}</span>
        <span>{{ option }}</span>
      </button>
    </mat-menu> -->

    <!-- Brand Selector Inline -->
    <div class="selector-bar-wrapper">
      <app-horizontal-selector-bar 
        [entityType]="config.entityType" 
        [maxCompetitors]="10"
        [projectId]="projectId"
        [availableOptions]="[]" 
        [selectedItems]="selectorItems"
        (selectionChange)="onSelectorSelectionChange($event)" 
        (compareClick)="onSelectorCompareClick($event)">
      </app-horizontal-selector-bar>
    </div>

    <!-- Analyze Button with Info Note (hidden per UI - preserved for re-enable) -->
    <!--
    <div class="analyze-section">
      <div class="action-buttons">
        <button mat-fab extended color="primary" 
                class="analyze-fab" 
                (click)="onAnalyzeClick()" 
                [disabled]="!isAnalyzeButtonEnabled()"
                matTooltip="Analyze selected brands" 
                matTooltipPosition="below">
          <mat-icon>insights</mat-icon>
          <span class="analyze-text">Analysis</span>
          @if(selectorItems.length > 1) {
          <span class="analyze-text"> & Compare</span>
          }
        </button>
      </div>
      <div class="competitor-limit-note" 
           matTooltip="Currently 5 competitors are allowed" 
           matTooltipPosition="below">
        <span class="limit-text">Note: Max 5 competitor allowed</span>
      </div>
    </div>
    -->
    <div class="analyze-section">
      <div class="action-buttons">
        @if(projectId && projectName) {
        <button mat-icon-button 
                class="history-button" 
                (click)="onHistoryClick()"
                matTooltip="View project history" 
                matTooltipPosition="below"
                color="primary">
          <mat-icon>history</mat-icon>
        </button>
        }
        @if(currentVersionName) {
        <span class="version-badge" matTooltip="Current version" matTooltipPosition="below">
          {{ currentVersionName }}
        </span>
        }
      </div>
    </div>
  </div>
</div>

<!-- @if(error){
  <div class="error">{{ error }}</div>
} -->
